import { render, staticRenderFns } from "./OfferTeaser.vue?vue&type=template&id=77eaefd7&"
import script from "./OfferTeaser.vue?vue&type=script&lang=js&"
export * from "./OfferTeaser.vue?vue&type=script&lang=js&"
import style0 from "./OfferTeaser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports